import { StatusChip, StatusChipColor } from "components/StatusChip";
import { WasteContainerStatus } from "generated-graphql/graphql";

import { CONTAINER_STATUS_LABELS } from "./containerDisplay";

const STATUS_COLORS: Record<WasteContainerStatus, StatusChipColor> = {
  [WasteContainerStatus.Staged]: "default",
  [WasteContainerStatus.Accumulating]: "info",
  [WasteContainerStatus.Full]: "warning",
  [WasteContainerStatus.PendingPickup]: "warning",
  [WasteContainerStatus.Shipped]: "success",
};

/**
 * The container's status, as the light-filled chip the design system specs.
 *
 * `soft` rather than `outlined`, matching the waste specs' container frames and
 * the shipment status chip beside it — a status that looked one way on the
 * shipment and another on the container would read as two different facts.
 */
export function WasteContainerStatusChip({ status }: { status: WasteContainerStatus }) {
  return (
    <StatusChip
      label={CONTAINER_STATUS_LABELS[status]}
      color={STATUS_COLORS[status]}
      variant="soft"
    />
  );
}
